import React, { useState, useEffect } from "react";
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  NavItem,
  NavLink,
  Nav,
  Col,
} from "reactstrap";
import classnames from "classnames";
import { DataTable, FilterBar } from "components/shared";

import {
  ResellerItemReportAPI,
  MANUAL_PEPORT,
} from "../../../services/CONSTANTS";
import { getApiDataService } from "../../../services/apiServices";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";

const COLUMNS = [
  { key: "index", label: "#", className: "text-center" },
  { key: "itemName", label: "Item Name", className: "text-center" },
  { key: "diaAmount", label: "Dia Amount", className: "text-center" },
  { key: "orderCount", label: "Order Count", className: "text-center" },
  { key: "totalUnit", label: "Total Unit", className: "text-center" },
];

function ResellerItemReport() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [item, setitem] = useState(null);

  const [activeNav, setActiveNav] = useState(1);
  const [game, setGame] = useState("Myanmar");

  let start = moment().startOf("day").toISOString();
  let end = moment().endOf("day").toISOString();
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const [reports, setReports] = useState([]);
  const [gameId, setGameId] = useState("649ef8db2f7c0933b90549f8");
  const [api, setApi] = useState("normal");
  const [region, setRegion] = useState(null);

  const [dateChangeEvent, setDateChangeEvent] = useState(true);

  useEffect(() => {
    fetchItemReport();
  }, [gameId, api, dateChangeEvent, region]);

  const fetchItemReport = () => {
    setIsLoading(true);
    let url =
      ResellerItemReportAPI + `?start_date=${startDate}&end_date=${endDate}`;
    getApiDataService(url)
      .then((res) => {
        setReports(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setReports([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  const toggleNavs = (e, index, val) => {
    e.preventDefault();
    setActiveNav(index);
    setGameId(val);
    setApi("normal");
  };

  const apiChooseHandler = (e, name) => {
    e.preventDefault();
    setApi(name);
  };

  const handleCallback = (start, end, label) => {
    console.log(start.toISOString(), "startDate1");
    console.log(end.toISOString(), "EndDate2");
    // moment('2020-06-05').format('YYYY-MM-DDTHH:mm:ssZ')
    setStartDate(start.toISOString());
    setEndDate(end.toISOString());

    setDateChangeEvent(!dateChangeEvent);
  };

  return (
    <>
      <Card className="shadow">
        <CardHeader className="border-0">
          <FilterBar title="Daily Orders Report">
            <DateRangePicker onCallback={handleCallback}>
              <input
                style={{ width: "200px" }}
                className="form-control"
                placeholder="Select date range"
                aria-label="Date range"
              />
            </DateRangePicker>
          </FilterBar>
        </CardHeader>
        <DataTable
          columns={COLUMNS}
          data={reports}
          isLoading={isLoading}
          emptyMessage="No records found"
          renderRow={(item, index) => (
            <tr key={item?.item_name ?? index}>
              <th className="text-center" scope="row">
                {index + 1}
              </th>
              <th className="text-center" scope="row">
                {item?.item_name}
              </th>
              <th className="text-center" scope="row">
                <Badge color="primary" pill className="font-mono">
                  {item?.unit_price}
                </Badge>
              </th>
              <td className="text-center font-mono">
                {item?.order_count.toLocaleString("en-US")}
              </td>
              <td className="text-center font-mono">
                {item?.total_unit?.toLocaleString("en-US")}
              </td>
            </tr>
          )}
          footer={
            reports.length > 0 ? (
              <tr style={{ borderTop: "2px solid #1a174d" }}>
                <td></td>
                <td className="text-right bg-gradient-default shadow text-white">
                  Total :
                </td>
                <td className="text-center font-mono">
                  {reports
                    .reduce((a, b) => a + b.unit_price, 0)
                    .toLocaleString("en-US")}
                </td>
                <td className="text-center font-mono">
                  {reports
                    .reduce((a, b) => a + b.order_count, 0)
                    .toLocaleString("en-US")}
                </td>
                <td className="text-center font-mono">
                  {reports
                    .reduce((a, b) => a + b.total_unit, 0)
                    .toLocaleString("en-US")}
                </td>
              </tr>
            ) : null
          }
        />
      </Card>
    </>
  );
}

export default ResellerItemReport;
